"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.uiStateConfig = exports.initShowTransactions = void 0;
const immutable_1 = require("immutable");
const core_1 = require("companion-app-components/utils/core");
const utils_1 = require("./utils");
const transactionsConfig = __importStar(require("./transactionsConfig"));
const log = (0, core_1.getLogger)('components/TransactionRegister/index.tsx');
/* eslint-disable react/sort-comp */
const RegisterUIState = (0, immutable_1.Record)({
    initNumberTxnsShown: 20,
    // Transient UI State
    txnBeingEdited: null,
    txnDirty: false,
    currEditFieldName: 'payee',
    showOnlineBalance: false,
    showEditMenu: null,
    tryNextRow: null,
    showNewTxn: false,
    showDocumentAdd: false,
    showDocumentBrowserTxn: null,
    showSplitWindow: false,
    showBulkEdit: false,
    simpleEdit: true,
    regEditableFields: (0, immutable_1.List)(),
    selectedTxns: (0, immutable_1.Set)(),
    sortAnimation: true,
    flashTx: null,
    openSections: (0, immutable_1.Set)([]),
    showAttachmentColumnInHeader: false,
    txnsFirstLoaded: 'default',
    searchBoxFilter: '',
    scrollToId: null,
    dataToDownload: null,
    allSelected: false,
    headerFields: null,
    lastAccountEntered: null,
    detailsRefSaveFn: null,
    reminderSetting: 0,
    filterObject: null,
});
const initShowTransactions = (passedProps, minNumVisible) => {
    let openSections = (0, immutable_1.Set)([]);
    if (passedProps.acctTxns) {
        let visibleCount = 0;
        passedProps.acctTxns.keySeq().forEach((key) => {
            if (visibleCount < minNumVisible) {
                const shortKey = key.slice(key.indexOf(':') + 1);
                openSections = openSections.add(shortKey);
                visibleCount += passedProps.acctTxns.get(key).size;
            }
        });
    }
    return openSections;
};
exports.initShowTransactions = initShowTransactions;
const initialUIStateConfig = (props) => {
    const ret = new RegisterUIState({
        regEditableFields: (0, utils_1.newRegFields)(props.doubleAmounts),
        openSections: (0, exports.initShowTransactions)(props, 300),
        headerFields: props.regFieldsOrder || (0, immutable_1.List)(transactionsConfig.getColumnDefaults()),
        reminderSetting: props.reminderSetting || 0,
    });
    log.log('INIT REGISTER STATE WITH ->', props, ret);
    return ret;
};
// NOTE: Only props established before USSTateConfig is called in the compose at the bottom of this
// class are going to be available to this section.
exports.uiStateConfig = {
    name: (props) => {
        let ret = `TxRegId_${props.wrapperId}:${props.accountNodeId}`;
        if (!props.accountNodeId) {
            if (props.accountIds && props.accountIds.size === 1) {
                ret = `${ret}${props.accountIds.first()}`;
            }
            else if (props.accountIds) {
                props.accountIds.forEach((v) => {
                    ret = `${ret}:${v}`;
                });
            }
        }
        return ret;
    },
    state: initialUIStateConfig,
    persist: true,
};
